const trackingEventResponseToTrackingEventObject = (response) => {
    return {
        id: response.id,
        userId: response.user_id,
        integrationId: response.integration_id,
        trackingNumber: response.tracking_number,
        carrier: response.carrier,
        service: response.service,
        packageType: response.package_type,
        carrierServiceId: response.carrier_service_id,
        createdAt: response.created_at,
        updatedAt: response.updated_at,
        timestamp: response.timestamp,
        status: response.status,
        statusDescription: response.status_description,
        carrierStatusCode: response.carrier_status_code,
        carrierStatusDescription: response.carrier_status_description,
        signerName: response.signer_name,
        cityLocality: response.city_locality,
        stateProvince: response.state_province,
        postalCode: response.postal_code,
        countryCode: response.country_code,
        longitude: response.longitude,
        latitude: response.latitude,
        serviceLevelGroup: response.service_level_group,
        dayServiceLevel: response.day_service_level,
        serviceLevelGuarantee: response.service_level_guarantee,
        ground: response.ground,
        domestic: response.domestic,
        errorMessage: response.error_message
    };
};

export { trackingEventResponseToTrackingEventObject };
